import { Collapse, Typography, styled } from '@mui/material'
import React from 'react'
import { colors } from '../../../../themes/colors'
import { TestIds } from '../../../../testIds'

export const HelperCollapse = styled(Collapse)(({ theme }) => ({
  background: theme.colors.primary100,
  color: theme.colors.primary500,
}))

export const CollapseContainer = styled('div')`
  display: flex;
  flex-direction: column;
  padding: 8px 16px;
`

interface HelperMessageProps {
  show: boolean
}
const RequestBulkHelperMessage: React.FC<HelperMessageProps> = ({ show }) => {
  return (
    <HelperCollapse in={show} data-testid={TestIds.feat.requestQuote.bulkBanner}>
      <CollapseContainer>
        <Typography color={colors.primary700} variant='body2' fontWeight='bold'>
          Looking to buy in bulk?
        </Typography>

        <Typography color={colors.primary700} variant='caption' fontWeight='regular'>
          Request a quote from your Farmlands representative.
        </Typography>
      </CollapseContainer>
    </HelperCollapse>
  )
}

export default RequestBulkHelperMessage
